import React, {Component} from 'react'
import {observer} from 'mobx-react'
import OfferFieldValueSourceSelect from "./OfferFieldValueSourceSelect"
import styles from './FieldMappingSettings.less'
import {IS_EMPTY, SPECIFIC} from "../../../../constant/ValueSourceType"
import InputText from "../../../../../lib/control/InputText"

const {
    'price-fields': price_fields,
    'price-fields-sign': price_fields_sign,
    'price-prop-field': price_prop_field,
    'add-price-field': add_price_field,
    'add-price-type-field': add_price_type_field,
    'add-price-fields-group': add_price_fields_group,
    'add-price-fields-group--wide': add_price_fields_group_wide,
} = styles

@observer export default class OfferFieldValueSourceSelectTypePrice extends Component {

    render() {
        const field = this.props.field;
        return (
            <div className={price_fields}>
                <div className={add_price_fields_group + ' ' + add_price_fields_group_wide}>
                    <div className={price_prop_field}>
                        <OfferFieldValueSourceSelect
                            context={this.props.context}
                            value_source={field.value}
                            field={field.dataset}
                        />
                    </div>
                </div>
            </div>
        )
    }

}